module.exports = __webpack_public_path__ + "img/safari.6725233c.svg";